import { Type } from '@angular/core';
import { DocumentComponent } from './document-models/documentComponent';
import { NotFoundDocumentComponent } from './not-found-document/not-found-document.component';
import { AppConstants } from 'src/utils/app.constants';

export default class DocumentUtils {
    
    static getNotFoundDocumentComponent(): Type<DocumentComponent> {
        return NotFoundDocumentComponent;
    }

    static getDocumentComponentTitleFromID(toolID: string): string {
        switch (toolID) {
            case 'pillid':
                return "Pill Identification";
            default:
                return "Tool title";
        }
    }
    
    static isDocumentTypeRequireHtmlDownload(docType: string): boolean {
        return docType !== AppConstants.DIRECTORY && docType !== AppConstants.MENU_TYPE && docType !== AppConstants.CLININFO_TOOLS_TYPE
            && docType !== AppConstants.NOT_FOUND_TYPE && docType !== AppConstants.TOOLS_TYPE && docType !== AppConstants.GENERIC_TYPE;
    }

    static removeEmptyDitaEntryTDs(rootElement: HTMLElement): void {
        const rows = rootElement.querySelectorAll('tr.dita-row');

        rows.forEach(row => {
            const ditaTds = row.querySelectorAll('td.dita-entry');

            if (ditaTds.length === 1) {
                const td = ditaTds[0];
                const html = td.innerHTML.trim();

                if (html === '&nbsp;') {
                    td.remove(); // Only remove the <td>, not the entire row
                }
            }
        });
    }

    static removeMoleculeDrugTableSubHeaders(docType: string, rootElement: HTMLElement): void {
        if (docType !== AppConstants.MONOGRAPH_TYPE || !rootElement) {
            return;
        }

        const productName = rootElement.querySelector('meta[name="prodname"]');
        if (productName && productName.getAttribute('content')?.trim().toLowerCase() === 'molecule') {
            rootElement.querySelectorAll('.drugTable .subHeader').forEach(subHeader => subHeader.remove());
        }
    }

    static updateElementClass(element: HTMLElement, ...classes: string[]): void {
        classes.forEach(className => {
            if (element.classList.contains(className)) {
                element.classList.remove(className);
            } else {
                element.classList.add(className);
            }
        });
    }
}
